import { IAppState } from '../../../../../AppModulesWrapper';
import { EBuyPackageSource } from '../../../../types/reducers/recommendedPackages';

export const selectRecommendedPackageSource = (state: IAppState): EBuyPackageSource | undefined => {
  return state.servicePickerWidgetV2.recommendedPackages.checkoutModalData.widgetSource;
};
